<div class="progress-circle" [ngClass]="{ over50: percentage > 0.5 }">
    <span>{{ percentage | percent }}</span>
    <div class="left-half-clipper">
        <div class="first50-bar"></div>
        <div class="value-bar" [ngStyle]="{ transform: getTransformStyle() }"></div>
    </div>
</div>
